export enum FeeNoChargeReasonEnum {
  Administrative      = '00000111-1000-0000-0000-000000000001',
  Charity             = '00000111-1000-0000-0000-000000000002',
  Latrogenic          = '00000111-1000-0000-0000-000000000003',
  InternalStaff       = '00000111-1000-0000-0000-000000000004',
  PersonalFriend      = '00000111-1000-0000-0000-000000000005',
  ReferringDrStaff    = '00000111-1000-0000-0000-000000000006',
  Religiouse          = '00000111-1000-0000-0000-000000000007',
  SeniorCitizen       = '00000111-1000-0000-0000-000000000008',
  Other               = '00000111-1000-0000-0000-000000000009'
}
